import { monteurApi } from '../common/monteur-api';
export var specialitiesApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['Specialities', 'Speciality', 'ActiveSpecialities']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        createSpeciality: builder.mutation({
            query: function (speciality) { return ({
                url: 'Speciality/create',
                method: 'POST',
                body: speciality
            }); },
            invalidatesTags: ['Specialities', 'ActiveSpecialities', 'Speciality']
        }),
        updateSpeciality: builder.mutation({
            query: function (speciality) { return ({
                url: 'Speciality/update',
                method: 'POST',
                body: speciality
            }); },
            invalidatesTags: ['Specialities', 'ActiveSpecialities', 'Speciality']
        }),
        updateSpecialityStatus: builder.mutation({
            query: function (speciality) { return ({
                url: 'Speciality/update-status',
                method: 'POST',
                body: speciality
            }); },
            invalidatesTags: ['Specialities', 'ActiveSpecialities', 'Speciality']
        }),
        getActiveSpecialities: builder.query({
            query: function (query) { return "Speciality/get-active?companyId=".concat(query.companyId); },
            providesTags: ['ActiveSpecialities']
        }),
        getSpecialitiesList: builder.query({
            query: function () { return "Speciality/get-all"; },
            providesTags: ['Specialities']
        }),
        getPaginatedSpecialities: builder.query({
            query: function (query) { return ({
                url: "Speciality/get-paginated",
                method: 'POST',
                body: query
            }); },
            providesTags: ['Specialities']
        }),
        getSpecialityById: builder.query({
            query: function (id) { return "Speciality/get-by-id?id=".concat(id); },
            providesTags: ['Speciality']
        }),
        deleteSpeciality: builder.mutation({
            query: function (id) { return ({
                url: "Speciality/delete?id=".concat(id),
                method: 'POST'
            }); },
            invalidatesTags: ['Specialities', 'ActiveSpecialities', 'Speciality']
        })
    }); }
});
export var useCreateSpecialityMutation = specialitiesApi.useCreateSpecialityMutation, useUpdateSpecialityMutation = specialitiesApi.useUpdateSpecialityMutation, useUpdateSpecialityStatusMutation = specialitiesApi.useUpdateSpecialityStatusMutation, useGetActiveSpecialitiesQuery = specialitiesApi.useGetActiveSpecialitiesQuery, useGetSpecialitiesListQuery = specialitiesApi.useGetSpecialitiesListQuery, useGetSpecialityByIdQuery = specialitiesApi.useGetSpecialityByIdQuery, useDeleteSpecialityMutation = specialitiesApi.useDeleteSpecialityMutation, useGetPaginatedSpecialitiesQuery = specialitiesApi.useGetPaginatedSpecialitiesQuery;
